import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";
import { register } from 'swiper/element/bundle';
register();

function SectionSlider1() {
    return (
        <>
            <div className="sx-bnr-1-wrap-outer home-1-slider" >
                {/* swiper slides */}
                <swiper-container
                    loop="true"
                    space-between="30"
                    effect="fade"
                    navigation-next-el=".swiper-button-next"
                    navigation-perv-el=".swiper-button-prev"
                    pagination-el=".swiper-pagination"
                    pagination-clickable="true"
                    autoplay-delay="7000"
                    autoplay-disable-on-interaction="true"
                    class="swiper-wrapper"
                >
                    <swiper-slide class="sx-bnr-1-wrap swiper-slide overlay-overlay">
                        <div className="sx-bg-overlay opacity-0 sx-bg-primary" />
                        <div >
                            <div className="row">
                                <div className="col-11 col-lg-5 sx-bnr-1-content">
                                    <span className="sx-bnr-1-small-title" data-swiper-parallax="-300" style={{letterSpacing: '0px' }}>افزایش بهره‌وری با ابزارهای سفارشی</span>
                                    <h2 className="sx-bnr-1-large-title">ویراپ ابزارهایی ارائه می‌دهد که بهره‌وری را افزایش و مدیریت را بهینه می‌کند.</h2>
                                    <div className="sx-bnr-1-info">تحلیل داده‌ها و توسعه نرم‌افزار، دقت در تصمیم‌گیری و بهره‌وری سازمان را افزایش می‌دهد.</div>
                                    <div className="sx-bnr-readmore">
                                        <NavLink to="/" className="site-button sx-btn-primary icon" style={{direction:'ltr'}}>
                                        <i className="fa  fa-long-arrow-left" />
                                        اطلاعات بیشتر
                                    </NavLink>
                                    </div>
                                    {/* <div className="sx-bnr-video">
                                    <a href="https://www.youtube.com/watch?v=c1XNqw2gSbU" className="mfp-video circle">
                                        <i className="flaticon-play" />
                                    </a>
                                </div> */}
                                </div>
                                <div className="col-12 col-lg-7 d-none d-lg-block">
                                    <img src="/assets/images/banner/hero-section-vira.png" style={{float:'left'}} alt="" />
                                </div>
                            </div>

                        </div>
                        {/* <div className="sx-bnr-text-masking">
                            <div className="light">
                                <h1 className="animate-charcter">IT Solution</h1>
                            </div>
                        </div> */}
                    </swiper-slide>

                </swiper-container>
                {/* !swiper slides */}
                {/* Add Arrows */}
                {/* <div className="swiper-button-next" /> */}
                {/* <div className="swiper-button-prev" /> */}
            </div>
        </>
    )
}

export default SectionSlider1;